@use '../../../scss/utility';

:host {
  display: block;
}

:host([tag='span']),
:host([tag='b']),
:host([tag='em']),
:host([tag='i']),
:host([tag='strong']),
:host([tag='small']) {
  display: inline;
}

.tag {
  @include utility.wb-type-normalizing;
  font: inherit;
  box-shadow: border-box;
  margin: 0;
}

:host([ellipsis]) {
  overflow: hidden;

  .tag {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

:host([size='s']) {
  @include utility.wb-heading(
    's',
    (
      includeSupStyles: false,
      includeSubStyles: false,
      includeNormalizations: false,
    )
  );
}

:host([size='xs']) {
  @include utility.wb-heading(
    'xs',
    (
      includeSupStyles: false,
      includeSubStyles: false,
      includeNormalizations: false,
    )
  );
}

:host([size='m']) {
  @include utility.wb-heading(
    'm',
    (
      includeSupStyles: false,
      includeSubStyles: false,
      includeNormalizations: false,
    )
  );
}

:host([size='l']) {
  @include utility.wb-heading(
    'l',
    (
      includeSupStyles: false,
      includeSubStyles: false,
      includeNormalizations: false,
    )
  );
}

:host([size='xl']) {
  @include utility.wb-heading(
    'xl',
    (
      includeSupStyles: false,
      includeSubStyles: false,
      includeNormalizations: false,
    )
  );
}

:host([chinese]) {
  --wb-font-title: var(--wb-font-title-chinese);
}

::slotted(sup) {
  @include utility.wb-superscript;
  position: relative;
  inset-block-end: 0.5em;
}

::slotted(sub) {
  @include utility.wb-subscript;
}
